<template>
	<div>
		<h4 class="mb-4">Contact gegevens</h4>
		<div class="vx-row mb-2">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="Adres" v-model="contact.address" />
			</div>
		</div>
		<div class="vx-row mb-2">
			<div class="vx-col w-full">
				<vs-input class="w-full" type="email" label-placeholder="Email" v-model="contact.email" />
			</div>
		</div>
		<div class="vx-row mb-6">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="Telefoonnummer" v-model="contact.phone" />
			</div>
		</div>
		<div class="vx-row mb-6">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="BTW nummer" v-model="contact.btw" />
			</div>
		</div>
		<div class="vx-row mb-6">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="KVK nummer" v-model="contact.kvk" />
			</div>
		</div>
		<div class="vx-row mb-6">
			<div class="vx-col w-full">
				<vs-textarea class="w-full" label="Openings tijden" v-model="contact.opening_hours" />
			</div>
		</div>
		<div class="vx-row mb-6">
			<div class="vx-col w-full">
				<vs-textarea class="w-full" label="Extra velden" v-model="contact.other" />
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<vs-button class="mr-3 mb-2" @click="saveContact()" color="success">Opslaan</vs-button>
			</div>
		</div>
	</div>
</template>
<script>
	import api from '../api';
	export default {
		name: 'Contact',
		components: {},
		props: {},
		data () {
			return {
				contact: {}
			}
		},
		computed: {

		},
		mounted () {
			this.getContact();
		},
		methods: {
			getContact(){
				api.post("admin/settings", {keys: ['contact']}).then(response=>{
					console.log(response);
					this.contact = response.data[0].value;
				}).catch((error)=>{
					console.log(error);
				})
			},
			saveContact(){
				api.put("admin/settings", {settings: {'contact': this.contact}}).then(()=>{
					this.$vs.dialog({
						title: 'Gelukt!',
						text: 'Opslaan van de contact gegevens is gelukt',
						color: 'success'
					})
				}).catch((error)=>{
					console.log(error);
				})
			},
		}
	}

</script>
